module.exports = __webpack_public_path__ + "img/comingsoon.3f67cfb4.png";